import { FC } from 'react';
import { BodyText, Stack } from '@servicetitan/design-system';

/**
 * Inline error panel for a failed job-number lookup (network / GraphQL
 * failure). Visually parallel to `JobNumberNotFound` so callers can swap based
 * on `SearchStatus.Error` without restructuring the layout, but the copy
 * tells the agent the search itself failed (so they don't retype a job
 * number they already know is correct).
 */
export const JobLookupError: FC = () => {
  return (
    <Stack direction='column' className='m-t-3' alignItems='center'>
      <BodyText el='span' className='ta-center' bold subdued>
        Couldn’t search for jobs
      </BodyText>
      <BodyText el='span' subdued className='ta-center m-t--half' size='small'>
        Something went wrong reaching the job service. Try again in a moment.
      </BodyText>
    </Stack>
  );
};
